import {get} from "lodash"
import BaseService from "./Base"
import {
    CreateMarketingCampaignLinkPayload,
    CreateMarketingCampaignPayload,
    DeleteMarketingCampaignLinksPayload,
    DeleteMarketingCampaignsPayload,
    EditMarketingCampaignLinkPayload,
    EditMarketingCampaignPayload,
    ListMarketingCampaignLinksPayload,
    ListMarketingCampaignsPayload
} from "types/marketing-campaigns"

class MarketingCampaignsService extends BaseService {
    getAllMarketingCampaigns = async (params: ListMarketingCampaignsPayload) => {
        const response = await this.post("/v1/marketing-campaigns/list", params)
        return get(response, "data", [])
    }

    createMarketingCampaign = async (params: CreateMarketingCampaignPayload) => {
        const response = await this.post("/v1/marketing-campaigns/create", params)
        return get(response, "data.data", {})
    }

    editMarketingCampaign = async (id: number, params: EditMarketingCampaignPayload) => {
        const response = await this.post("/v1/marketing-campaigns/edit", {...params, id})
        return get(response, "data.data", {})
    }

    deleteMarketingCampaigns = async (params: DeleteMarketingCampaignsPayload) => {
        const response = await this.post("/v1/marketing-campaigns/delete", params)
        return get(response, "data.data", {})
    }

    getAllMarketingCampaignLinks = async (params: ListMarketingCampaignLinksPayload) => {
        const response = await this.post("/v1/marketing-campaigns/list-links", params)
        return get(response, "data", [])
    }

    createMarketingCampaignLink = async (params: CreateMarketingCampaignLinkPayload) => {
        const response = await this.post("/v1/marketing-campaigns/create-link", params)
        return get(response, "data.data", {})
    }

    editMarketingCampaignLink = async (id: number, params: EditMarketingCampaignLinkPayload) => {
        const response = await this.post("/v1/marketing-campaigns/edit-link", {...params, id})
        return get(response, "data.data", {})
    }

    deleteMarketingCampaignLinks = async (params: DeleteMarketingCampaignLinksPayload) => {
        const response = await this.post("/v1/marketing-campaigns/delete-link", params)
        return get(response, "data.data", {})
    }
}

export default MarketingCampaignsService
